export default __webpack_public_path__ + "b5681970dd224c4d2f598cda033226f8.png";